import {NEW_URL_FACET_SEPARATOR} from "../../config/constants"

export type Filter = {
    filterName: string
    filterValue: string
}

const getFilters = (pathPart: string): Filter[] => {
    if (!pathPart) return []
    let state: "filter" | "facet" = "filter"
    const filters: Filter[] = []
    let tempFilterName = ""
    let tempFilterValue = ""
    pathPart.split("").forEach(char => {
        if (char === "-") {
            if (state === "filter") {
                state = "facet"
                return
            }
            if (state === "facet") {
                state = "filter"
                filters.push({
                    filterName: tempFilterName,
                    filterValue: tempFilterValue,
                })
                tempFilterName = ""
                tempFilterValue = ""
                return
            }
        }
        if (char === NEW_URL_FACET_SEPARATOR) {
            filters.push({
                filterName: tempFilterName,
                filterValue: tempFilterValue,
            })
            tempFilterValue = ""
            return
        }
        if (state === "filter") tempFilterName += char
        if (state === "facet") tempFilterValue += char
    })
    filters.push({
        filterName: tempFilterName,
        filterValue: tempFilterValue,
    })
    return filters
}

export const getFiltersWithoutPriceAndSort = (pathPart: string): Filter[] => {
    const filters = getFilters(pathPart)
    return filters.filter(f => f.filterName !== "minprice" && f.filterName !== "maxprice" && f.filterName !== "isort")
}

export default getFilters
